import { useEffect, useState } from "react";
import { History, Trash2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useApi, errMsg } from "@/lib/api";
import ScanImage from "@/components/app/ScanImage";

const fmt = (iso) => new Date(iso).toLocaleString("it-IT", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });

export default function HistoryTab({ onOpenScan }) {
  const api = useApi();
  const [scans, setScans] = useState(null);
  useEffect(() => { api("get", "/scans").then(setScans).catch(() => setScans([])); }, [api]);

  const remove = async (e, id) => {
    e.stopPropagation();
    try {
      await api("delete", `/scans/${id}`);
      setScans(scans.filter((s) => s.id !== id));
      toast("Scansione eliminata");
    } catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <div data-testid="history-tab">
      <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight">Frighi analizzati</h1>
      {scans === null ? <Loader2 className="mt-10 h-6 w-6 animate-spin text-[#2E6F40]" />
        : scans.length === 0 ? (
          <div className="mt-10 flex flex-col items-center text-center text-[#4F5D52] gap-3 py-16" data-testid="history-empty">
            <History className="h-10 w-10 text-[#2E6F40]" strokeWidth={1.5} />
            <p>Ancora nessuna foto analizzata.</p>
          </div>
        ) : (
          <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {scans.map((s, i) => (
              <div key={s.id} data-testid="history-item" onClick={() => onOpenScan(s)}
                className="rise group cursor-pointer overflow-hidden rounded-3xl border border-[#1C241E]/10 bg-white transition-[transform,box-shadow] hover:-translate-y-1 hover:shadow-xl"
                style={{ animationDelay: `${i * 0.05}s` }}>
                <ScanImage scanId={s.id} className="aspect-[16/10] w-full object-cover" />
                <div className="p-4">
                  <div className="flex items-center justify-between">
                    <p className="font-mono text-xs text-[#4F5D52]">{fmt(s.created_at)}</p>
                    <button data-testid="history-delete-button" onClick={(e) => remove(e, s.id)} aria-label="Elimina"
                      className="rounded-full p-1.5 text-[#4F5D52] hover:bg-[#FDF0ED] hover:text-[#D95338]"><Trash2 className="h-4 w-4" /></button>
                  </div>
                  <p className="mt-1 font-semibold">{s.ingredients.length} ingredienti · {s.recipes.length} ricette</p>
                  <p className="mt-1 text-sm text-[#4F5D52] line-clamp-1">{s.ingredients.map((x) => x.name).join(", ")}</p>
                </div>
              </div>
            ))}
          </div>
        )}
    </div>
  );
}
